import { render, staticRenderFns } from "./AddEventCalendar.vue?vue&type=template&id=21c82026&"
import script from "./AddEventCalendar.vue?vue&type=script&lang=js&"
export * from "./AddEventCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports